export default "__VITE_ASSET__CSUNQtjt__"